/** @jsx jsx */
import { jsx } from "@emotion/react";
import { useIntl } from "react-intl";
import { useTheme } from "../../../../config/emotion";

import EwaButton2 from "./EwaButton/EwaButton2";
import { PurposedButtonProps } from "./types";
import { labellessButtonCss } from "./styles";

const AssignButton = (props: PurposedButtonProps) => {
  const { formatMessage } = useIntl();
  const { colors } = useTheme();

  return (
    <EwaButton2
      buttonColor={colors.secondaryColor}
      tooltip={formatMessage({ id: "roles.add_roles" })}
      iconName="compare_arrows"
      css={labellessButtonCss}
      {...props}
      dataCy="assign-button"
    />
  );
};

export default AssignButton;
